import React from 'react'

import Logo from './styles'

const SiteLogo: React.FC = (): React.ReactElement => <Logo className='siteLogo' />

export default SiteLogo
